import React from 'react'
import { useHistory } from 'react-router-dom'

export default function DataSidebar({page}) {

    const history = useHistory()

    return (
        <div className='textBox'>
            <div className='content' style={{fontSize:'15px',cursor:'pointer'}} >
                <table className='table table-sm table-hover' style={{marginTop:'5px'}} >
                    <tbody style={{fontWeight:'bold'}} >
                        <tr>
                            <td><button onClick={()=> history.push('/dashboard/data')} className={page == 0 ? 'greenBtn' : 'whiteBtn'}>Anasayfa</button></td>
                        </tr>
                        <tr>
                            <td><button onClick={()=> history.push('/dashboard/data/hsign')} className={page == 1 ? 'greenBtn' : 'whiteBtn'}>Numarataj</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
